const { handleError, handleResponse } = require("./baseApi");
const axios = require("axios");
const api_config = require("./api_config");

function getGeoLocationApi() {
    return axios.create({
        baseURL: `https://api.ipgeolocation.io/`,
        timeout: 20000,
        headers: {
            "content-type": "application/json"
        }
    }).get(api_config.geo_location_key === "NA" ?
        `ipgeo` : `ipgeo?apiKey=${api_config.geo_location_key}`)
        .then(handleResponse)
        .catch(handleError);
}

module.exports = { getGeoLocationApi };
